import BaseApi from '@/includes/services/BaseApi'

import { BindTargetByCode, BindTargetByCodeRes } from 'piramis-base-components/src/shared/types/BindTarget.types';

export default class BindTargetApi {
    static async bindTargetByCode(type:string, body: BindTargetByCode) {
        return BaseApi.sendRequest<BindTargetByCodeRes>(type, 'bindtargetbycode', body)
    }
}